// 引入重置样式
import "../../../style/reset.scss";
// 导入公共样式
import "../../../style/index.scss";
// 一定要在main.ts中导入tailwind.css，防止vite每次hmr都会请求src/style/index.scss整体css文件导致热更新慢的问题
import "../../../style/tailwind.css";
import "./theme/style/element-plus.scss";
// 导入字体图标
import "./theme/iconfont/iconfont.css";
import "./theme/font/font.css";
import "virtual:svg-icons-register";

import { MotionPlugin } from "@vueuse/motion";
import ElementPlus from "element-plus";
import { createApp } from "vue";

import { useI18n } from "@/plugins/i18n";
import { setupStore } from "@/store";
import { injectResponsiveStorage } from "@/utils/responsive";
import { optimizeQiniuImage } from "@/utils/tool";

import App from "./App.vue";
// 全局注册组件
import { useComponents } from "./components";
import { initDirective } from "./directives/index";
import router from "./router";
import { initTheme } from "./theme";
const app = createApp(App);

app.config.globalProperties.$optimizeQiniuImage = optimizeQiniuImage;

// 自定义指令
import * as directives from "@/directives";
Object.keys(directives).forEach(key => {
  app.directive(key, directives[key]);
});

app.use(router);

injectResponsiveStorage(app);
setupStore(app);
initTheme();
initDirective(app);
app.use(MotionPlugin).use(useI18n).use(ElementPlus).use(useComponents);
app.mount("#app");
